/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Switch, Badge, KPI, Modal, ConfirmModal, toast, EMPLOYEES, PAY_TERMS, PAY_HOLIDAY, PAY_PENSION, PAY_RUNS, PAY_TYPES, PAY_SETTINGS, fmt, fmt0, PlummePayrollRunPeriod */
/* global React, Icon, Card, CardHead, Button, IconButton, Field, Input, Select, Currency, Switch, Badge, KPI, Modal, ConfirmModal, toast, EMPLOYEES, PAY_TERMS, PAY_HOLIDAY, PAY_PENSION, PAY_RUNS, PAY_TYPES, PAY_SETTINGS, fmt, fmt0, PlummePayrollRunPeriod */
// ============================================================
// PLUMME 2.0 — Lønn subpages (payroll) + shared dialogs
// Functionality modelled on the Plumme payroll report section.
// ============================================================
const { useState: usePayState, useEffect: usePayEffect } = React;

const PAY_PAGES = () => [
  { value: 'employees', label: t('pay.employees') },
  { value: 'payment', label: t('pay.payrollRun') },
  { value: 'tax', label: t('pay.agaAndTaxTab') },
  { value: 'pension', label: t('pay.pensionOtpTab') },
  { value: 'fixed', label: t('pay.fixedSalaryLines') },
  { value: 'travel', label: t('pay.travelAndExpenses') },
  { value: 'overview', label: t('pay.overview'), sep: true },
  { value: 'holiday', label: t('pay.holidayPayList') },
  { value: 'settings', label: t('pay.payrollSettings') },
  { value: 'paytypes', label: t('pay.salaryTypesAndDeductions') },
];

function PayNav({ value, onChange }) {
  const [open, setOpen] = usePayState(false);
  const pages = PAY_PAGES();
  const cur = pages.find((p) => p.value === value) || pages[0];
  return <div className="popwrap pay-nav">
    <button className="btn btn-secondary" onClick={() => setOpen((o) => !o)} style={{ minWidth: 250, justifyContent: 'space-between' }}>
      <span className="row gap-8"><Icon name="wallet" size={18} />{cur.label}</span><Icon name="chevDown" size={16} />
    </button>
    {open && <React.Fragment>
      <div className="pop-scrim" onClick={() => setOpen(false)} />
      <div className="pop pop-menu left" style={{ minWidth: 270 }}>
        {pages.map((p) => <React.Fragment key={p.value}>
          {p.sep && <div style={{ height: 1, background: 'var(--border)', margin: '6px 8px' }} />}
          {/* Lenke, ikke knapp: hver lonnsunderside har egen adresse og kan apnes i nytt vindu. */}
          <a href={window.navHref?.('lonn', p.value)} onClick={window.navClick ? window.navClick(() => { onChange(p.value); setOpen(false); }) : () => { onChange(p.value); setOpen(false); }} style={p.value === value ? { background: 'var(--plum-50)', color: 'var(--plum-700)' } : null}>{p.label}</a>
        </React.Fragment>)}
      </div>
    </React.Fragment>}
  </div>;
}

const payBadgeMeta = () => ({
  opptjent: ['neutral', t('pay.earned')],
  'holiday-unpaid': ['warning', t('pay.recon.notPaid')],
  betalt: ['success', t('pay.status.paid')],
  ikke: ['warning', t('pay.status.unpaid')],
  utbetalt: ['success', t('pay.paidOut')],
  godkjent: ['neutral', t('pay.status.approved')],
  annullert: ['muted', t('pay.status.annulled')],
  utkast: ['warning', t('pay.status.draft')],
  paid: ['success', t('pay.paidOut')],
  delvis: ['neutral', t('pay.status.partiallyPaid')],
});
function PayBadge({ s }) {
  const [v, l] = payBadgeMeta()[s] || ['muted', s];
  return <Badge variant={v}>{l}</Badge>;
}
function PaySubHead({ title, sub, action, help, helpTitle }) {
  return <div className="row between wrap gap-12" style={{ marginBottom: 16, alignItems: 'flex-start' }}>
    <div><h2 className="t-h1" {...(help ? { 'data-help': help, 'data-help-title': helpTitle || title } : {})}>{title}</h2>{sub && <div className="t-sm muted" style={{ maxWidth: 560, marginTop: 4 }}>{sub}</div>}</div>
    {action}
  </div>;
}

// ---- shared dialog (built on the shared Modal component) ----
function PayDialog({ open, onClose, title, onSave, saveLabel = t('pay.save'), children, max = 560 }) {
  return <Modal open={open} onClose={onClose} title={title} max={max}
    footer={onSave
      ? <React.Fragment><Button variant="ghost" onClick={onClose}>{t('pay.cancel')}</Button><Button icon="check" onClick={onSave}>{saveLabel}</Button></React.Fragment>
      : <Button variant="secondary" onClick={onClose}>{t('pay.close')}</Button>}>
    <div className="col gap-14" style={{ paddingBottom: 4 }}>{children}</div>
  </Modal>;
}
function PayKV({ rows }) {
  return <dl className="pay-detail-facts">{rows.map(([k, v]) => <div className="pay-detail-fact" key={k}><dt>{k}</dt><dd>{v}</dd></div>)}</dl>;
}

Object.assign(window, { PAY_PAGES, PayNav, PayOverview, PayTax, PayPension, PayHoliday, PayRuns, PayTypes, PayFixedLines, PaySettings, FixedPayrollLineDialog });
